export default __webpack_public_path__ + "static/media/maor-zur.0e97fe00.png";